var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.556,
    height: 15.556,
    viewBox: "0 0 15.556 15.556",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_108788",
    "data-name": "Group 108788",
    transform: "translate(-1049 -5380)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-linkedin-in",
    "data-name": "Icon awesome-linkedin-in",
    d: "M3.482,15.556H.257V5.171H3.482ZM1.868,3.754A1.877,1.877,0,1,1,3.735,1.868,1.884,1.884,0,0,1,1.868,3.754Zm13.685,11.8H12.334V10.5c0-1.2-.024-2.75-1.677-2.75-1.677,0-1.934,1.309-1.934,2.663v5.143H5.5V5.171H8.6V6.587H8.64A3.389,3.389,0,0,1,11.692,4.91c3.264,0,3.864,2.149,3.864,4.941v5.705Z",
    transform: "translate(1049 5379.999)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.75e1e5485f4f8de26d795dba1d3c2c0a.svg";
export { ForwardRef as ReactComponent };